'use client'

import { Provider } from 'react-redux'
import { useRef } from 'react'
import { makeStore, AppStore } from '../lib/store'

export default function StoreProvider({
  children,
  preloadedState
}: {
  children: React.ReactNode
  preloadedState?: any
}) {
  const storeRef = useRef<AppStore>(null)
  if (!storeRef.current) {
    storeRef.current = makeStore(preloadedState)
  }

  return <Provider store={storeRef.current}>{children}</Provider>
}
